import { render } from "./Principles.vue?vue&type=template&id=0e7f4bd6&scoped=true"
import script from "./Principles.vue?vue&type=script&lang=js"
export * from "./Principles.vue?vue&type=script&lang=js"

import "./Principles.vue?vue&type=style&index=0&id=0e7f4bd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7f4bd6"]])

export default __exports__